import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { SVG_MUI } from "@ryde/assets";
import { AccessControl, FramerTooltip } from "@ryde/controls";
import { ICourseDto, useIsMobile } from "@ryde/shared";

import { ButtonHeader } from "../../../../right";
import { useCourseDeepRecalculate } from "./use-course-deep-recalculate";

interface ICourseDeepRecalculateButtonProps {
  courseDto: Partial<ICourseDto> | undefined;
}

export const CourseDeepRecalculateButton: FC<
  ICourseDeepRecalculateButtonProps
> = ({ courseDto }) => {
  const { t } = useTranslation();
  const { isMobile } = useIsMobile();

  const { isLoading, handleDeepRecalculate } =
    useCourseDeepRecalculate(courseDto);

  const handleButtonClick = useEvent(() => {
    void handleDeepRecalculate();
  });

  return (
    <AccessControl entity="course" action="update">
      <div className="rebuild-route-button-container2">
        <FramerTooltip content={t(`general.DEEP_RECALCULATE_TOOLTIP`)}>
          <ButtonHeader onClick={handleButtonClick} disabled={isLoading}>
            <SVG_MUI.ArrowsRotate3SVG data-e2e="course-deep-recalculate-svg" />
            {!isMobile && <span>{t(`general.DEEP_RECALCULATE`)}</span>}
          </ButtonHeader>
        </FramerTooltip>
      </div>
    </AccessControl>
  );
};
